var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{class:{
            'required-field':
                _vm.field.section == 'register-setup-profile' ? false : true,
        },attrs:{"label":"ID Document Type","label-for":"documentType"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:({
                required:
                    _vm.field.section == 'register-setup-profile'
                        ? false
                        : true,
            }),expression:"{\n                required:\n                    field.section == 'register-setup-profile'\n                        ? false\n                        : true,\n            }"}],staticClass:"form-control",class:{
                'is-invalid': _vm.errors.has('document type'),
            },attrs:{"options":_vm.options,"disabled":_vm.loading || _vm.disabled,"data-vv-name":"document type"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('option',{attrs:{"slot":"first","disabled":""},domProps:{"value":null},slot:"first"},[_vm._v("\n                "+_vm._s(_vm.field.placeholder)+"\n            ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }